/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../sidebar/Footer";
import SocialMediaIcons from "./SocialMedia";

const WelcomePage = () => {
    const navigate = useNavigate();
    const GoButton = () => {
        navigate("/subscriptions");
    }
    return (
        <section className="container">
            {/* Header Section */}
            <header className="text-center py-0">
                <img
                    className="img-fluid"
                    src="/assets/images/logo.svg"
                    alt="FRAYO Logo"
                    style={{ height: "80px" }}
                />
                <h1 className="fw-bold text-success mt-4">Welcome to FRAYO Affiliate</h1>
                <p className="text-muted mt-3 ">
                    Elevate your culinary journey with subscription plans designed for chefs and food enthusiasts alike.
                </p>
            </header>

            {/* Description Section */}
            <section className="text-center my-1 ">
                <p className="text-muted py-5">
                    <strong className="text-success">FRAYO</strong> offers flexible subscription plans to meet diverse needs. Whether you're a chef
                    growing your business or a food lover exploring gourmet delights, our platform provides all the tools and opportunities you need to succeed.
                </p>
                <button className="btn btn-outline-success mt-3 rounded-5 px-4 md-3"
                    onClick={GoButton}>Go</button><br />
            </section>

            {/* Footer Section */}
            <div className="mt-5 my-5">   <Footer /></div>

        </section>
    );
};

export default WelcomePage;
